// @core/api/endpoints/tenant/list_tenants.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListTenantsResponse,
} from '../../../types/tenant';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/tenant';

/**
 * List tenants (respects privacy settings)
 * Returns a paginated list of tenants visible to the caller. Platform admins see all tenants, while regular users see tenants they belong to plus public tenants shown in the directory.
 */
export async function ListTenants(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListTenantsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/`;
  const requestOptions = options;
  return client.get<ListTenantsResponse>(requestPath, { ...requestOptions, params });
}
